import { render, staticRenderFns } from "./PlanejamentoAcaoJustificativa.vue?vue&type=template&id=12143adf"
import script from "./PlanejamentoAcaoJustificativa.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports